import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { appleLogin } from "./Action";
import { useDispatch } from "react-redux";
import { Userpilot } from "userpilot";
import Utils from "../../../utils";
import CustomSpinner from "../../../common/CustomSpinner";

export default function OAuthCallback({ provider })  {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  function trackUser(data) {
      Userpilot.identify(data?.user?.id,{
          role: data?.user?.role,
          email: data?.user?.email,
          created_at: data?.user?.profile?.created_at,
          user_verified: data?.user?.is_active,
          subscription: false,
          company: data?.user?.vendor ? {
              id: data?.user?.vendor?.id,
              name: data?.user?.vendor?.business_name,
          }: 'N/A',
      });
  }

  useEffect(() => {
    sessionStorage.removeItem('OAUTH_IN_PROGRESS');
  }, []);



  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const first_name = params.get("first_name");
    const last_name = params.get("last_name");
    const role = params.get("role") || "user";
    const state = params.get("state");
    const obj = state ? JSON.parse(decodeURIComponent(state)) : {};
    const endpointType = obj.role === "DT" ? "dealerTechnicianEndpoints" : "userMobileEndpoints";

    if (!code || !provider) return;
    if(provider === "google"){
      window.location.replace(
      `${obj.domain}${Utils.EndPoint[endpointType].auth}?code=${code}&oauth_type=google`
      );
    }

    if(provider === "apple"){
     appleLogin(code, navigate, dispatch, role, trackUser, first_name, last_name);
    }

  }, [provider]);

  return <CustomSpinner fullPage top={0} />;
}
